function getAllCollapses(buttonsContainer) {
    const portletBody = buttonsContainer === null || buttonsContainer === void 0 ? void 0 : buttonsContainer.closest('.portlet-body');
    const collapseTitles = portletBody === null || portletBody === void 0 ? void 0 : portletBody.querySelectorAll('.ecollapse-title');
    const collapseContents = portletBody === null || portletBody === void 0 ? void 0 : portletBody.querySelectorAll('.ecollapse-content');
    return [collapseTitles, collapseContents];
}
function doWithCollapses(buttonsContainer, action) {
    const [collapseTitles, collapseContents] = getAllCollapses(buttonsContainer);
    if (collapseTitles && collapseContents) {
        action(collapseTitles, collapseContents);
    }
}
export function openAllCollapses(buttonsContainer) {
    doWithCollapses(buttonsContainer, (collapseTitles, collapseContents) => {
        collapseTitles.forEach((el) => {
            el.classList.add('open');
        });
        collapseContents.forEach((el) => {
            el.classList.remove('hide');
        });
    });
}
export function closeAllCollapses(buttonsContainer) {
    doWithCollapses(buttonsContainer, (collapseTitles, collapseContents) => {
        collapseTitles.forEach((el) => {
            el.classList.remove('open');
        });
        collapseContents.forEach((el) => {
            el.classList.add('hide');
        });
    });
}
